import { render } from "./Register.vue?vue&type=template&id=6811db98&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=6811db98&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6811db98"

export default script